import React from "react";
import Reveal from "./Reveal";
import { useLang } from "../lib/lang-context";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export default function FAQ() {
  const { t } = useLang();
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-white dark:bg-zinc-950 border-t border-slate-200 dark:border-zinc-800"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-4">
            <p className="text-xs tracking-[0.24em] uppercase font-bold text-[var(--icor-blue)] eyebrow-line">
              {t.faq.eyebrow}
            </p>
            <h2 className="font-display text-4xl md:text-5xl font-semibold tracking-tighter mt-5 text-[var(--icor-navy)] dark:text-white text-balance">
              {t.faq.title}
            </h2>
          </Reveal>

          <Reveal delay={150} className="lg:col-span-8">
            <Accordion
              type="single"
              collapsible
              className="border-t border-slate-200 dark:border-zinc-800"
            >
              {t.faq.items.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-slate-200 dark:border-zinc-800"
                >
                  <AccordionTrigger className="text-left font-display text-lg md:text-xl font-medium tracking-tight text-[var(--icor-navy)] dark:text-white hover:no-underline py-6">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 dark:text-zinc-400 text-base leading-relaxed pb-6">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
